<div [@slideInOut]="field.hide ? 'out' : 'in'">
  <ng-container #fieldComponent></ng-container>
</div>
